// The red asterisk shown after a required field's label. Decorative only
// (aria-hidden) — actual validation flows through zod / react-hook-form.
export function RequiredMark() {
  return (
    <span aria-hidden="true" className="ml-0.5 text-red-600">
      *
    </span>
  );
}
